







import { ref, defineComponent, computed, PropType, watch } from '@vue/composition-api';
import { scriptLoader } from '@/utils/scriptLoader';

export default defineComponent({
  name: 'MathContent',
  props: {
    content: {
      type: String as PropType<string>
    },
    picList: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  },
  setup(props, { root, emit }: any) {
    const contentRef = ref<HTMLElement>();
    const loading = ref(true);

    /**
     * 是否需要数学公式解析
     */
    const isLatex = computed(() => {
      return /\$.+\$/.test(props.content);
    });

    /**
     * 需要渲染的富文本
     */
    const html = computed(() => {
      return contentImgSrcFix(props.content);
    });

    watch(
      () => loading.value,
      newVal => {
        // loading 为 false 的情况下代表 mathjax 完成
        if (!newVal) {
          emit('mathLoadedHandle');
        }
      }
    );

    watch(
      () => props.content,
      () => {
        if (!isLatex.value) {
          loading.value = false;
          return;
        }
        root.$nextTick(() => {
          repaint();
        });
      },
      { immediate: true }
    );

    /**
     * 加载 mathjax
     */
    const repaint = async () => {
      if (!(window as any).MathJax?.Hub?.Queue) {
        console.log('load mathjax start!');

        const res = await scriptLoader(
          'https://mathjax.cdnjtzy.com/static/hy/mathjax_274/mathjax/MathJax.js?config=svgsnippet-update20201111',
          'MathJax'
        );

        console.log('load mathjax script:', res);
        latexRender();
      } else {
        console.log('mathjax script has loaded', (window as any).MathJax);
        latexRender();
      }
    };

    /**
     * mathjax解析并处理回调
     */
    const latexRender = () => {
      root.$nextTick(() => {
        try {
          (window as any).MathJax.Hub.Queue([
            'Typeset',
            (window as any).MathJax.Hub,
            contentRef.value,
            () => {
              loading.value = false;
            }
          ]);
        } catch (e) {
          loading.value = false;
        }
      });
    };

    /**
     * 异常图片链接兼容
     * @param html 需要解析的文本
     */
    function contentImgSrcFix(html: string) {
      // <img src=\"https://img.zuoyebang.cc/zyb_282b9433d3cb3f1035b7e8550b8e11d3.jpg\"
      return html
        ? html.replace(
            /src=["'](https:\/\/img\.zuoyebang\.cc\/tk_)(https:\/\/img.zuoyebang.cc\/.*\.jpg)\.jpg["']/g,
            'src="$2"'
          )
        : '';
    }

    return {
      loading,
      html
    };
  }
});
